import { FC } from 'react';
import { FormProps } from '../../helpers';
import Switch from '../../switch';
import { McpAction } from '@/lib/models/policy-model-v1/mcp-controls';

interface Props extends FormProps {
  value: McpAction;
  onChange: (action: McpAction) => void;
}

const McpToolActionSwitchV1: FC<Props> = ({ value, onChange, ...rest }) => {
  const handleChange = (value: boolean) => {
    onChange(value ? 'read' : 'read-write');
  };

  return <Switch checked={value === 'read'} onChange={handleChange} {...rest} />;
};

export default McpToolActionSwitchV1;
